export default class ScrollHinter {
  constructor(el) {
    this.el = el;
    this.parent = this.el.parentNode;

    this.checkScroll = this._checkScroll.bind(this);
    this._bindEvents();

    this._checkScroll();
  }

  _checkScroll() {
    const { scrollLeft, scrollWidth } = this.el;
    const { width } = this.el.getBoundingClientRect();

    const overflowsLeft = scrollLeft > 0;
    const overflowsRight = scrollLeft < scrollWidth - width;

    this._toggleClasses({ overflowsLeft, overflowsRight });
  }

  unload() {
    this.el.removeEventListener('scroll', this.checkScroll);

    this._toggleClasses({ overflowsLeft: false, overflowsRight: false });
  }

  _bindEvents() {
    this.el.addEventListener('scroll', this.checkScroll);
  }

  _toggleClass(el, className, condition) {
    if (condition) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  _toggleClasses(overflows = {}) {
    const { overflowsLeft, overflowsRight } = overflows;

    this._toggleClass(this.parent, 'overflows-left', overflowsLeft);
    this._toggleClass(this.parent, 'overflows-right', overflowsRight);
  }
}
